import { Flex, FormHelperText } from '@chakra-ui/react';
import { MarkdownIcon } from '@components/icons';

const MarkdownTip = () => {
  return (
    <FormHelperText><Flex align="center"><MarkdownIcon w={5} h={5} mr={2} />Supports Markdown</Flex></FormHelperText>
  );
}

export default MarkdownTip;